<template>
  <div style="text-align:left" class="user-role">
    <el-transfer v-model="userRoles" :data="roles" :titles="['可分配角色', '已分配角色']" @change="transferChange" @right-check-change="rightCheckChange" :class="{ currentuser: $store.getters.userId == userId }"></el-transfer>
  </div>
</template>
<script>
import request from '@/utils/request'
export default {
  name: 'UserRole',
  props: {
    userId: {
      required: true
    }
  },
  data() {
    return {
      roles: [],
      userRoles: []
    }
  },
  watch: {
    userId: function(newValue, oldValue) {
      this.fetchTransferData()
    }
  },
  methods: {
    fetchTransferData() {
      const loading = this.$loading({
        lock: true,
        text: '加载中......',
        target: '.user-role'
      })
      request({
        url: '/user/roles',
        method: 'get',
        params: {
          userId: this.userId
        }
      })
        .then(response => {
          const data = response.data
          const allRoles = data.allRoles
          const userRoles = data.userRoles
          const _userRoles = []

          this.roles = allRoles.map(item => {
            const exists = userRoles.some(e => {
              return e.roleId === item.id
            })
            if (exists) {
              _userRoles.push(item.id + '|' + (item.code ? item.code : ''))
              // return { key: item.id, label: item.name }
            }
            return {
              key: item.id + '|' + (item.code ? item.code : ''),
              label: item.name
            }
          })
          console.log(this.roles)
          // this.userRoles = _userRoles
          this.userRoles = userRoles.map(item => {
            return item.id + '|' + (item.code ? item.code : '')
          })
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => {
          loading.close()
        })
    },
    transferChange(value, direction, roleIdCodes) {
      request({
        url: '/user/roles',
        method: direction === 'right' ? 'post' : 'delete',
        params: {
          userId: this.userId,
          roleIdCodes: roleIdCodes.join(',')
        }
      })
        .then(response => {
          this.$message('操作成功')
          request({
            url: '/iblac/roles/signSave',
            method: 'post',
            params: {
              userId: this.userId,
              roleIdCodes: roleIdCodes.join(',')
            }
          }).then(response => {
            console.log("签字验签返回的数据为：",response);
          }).catch(error => {
            console.log(error)
          })
        })
        .catch(error => {
          console.log(error)
        })
    },
    rightCheckChange() {
      if (this.$store.getters.userId === this.userId) {
        this.$message('不能自己管理自己的角色，只能由上级管理员管理你的角色')
      }
    }
  }
}
</script>
<style lang="scss">
.user-role .el-transfer-panel {
  width: 100%;
}
.user-role .el-transfer__buttons {
  text-align: center;
  width: 100%;
}
.user-role .el-transfer__button {
  display: inline-block;
}
.user-role .el-transfer__button:first-child {
  margin: 10px 10px;
}
.user-role .el-transfer__button:first-child .el-icon-arrow-left:before {
  content: '\E6DF';
}
.user-role .el-transfer__button:nth-child(2) .el-icon-arrow-right:before {
  content: '\e6e1';
}
.currentuser .el-transfer__buttons {
  visibility: hidden;
}
.user-role {
  .el-transfer {
    display: flex;
    flex-direction: column-reverse;
    justify-content: flex-end;
  }
}
</style>
